import { contactInfo } from '@/pages/home/mocks/data';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3">
          投稿通道
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">{contactInfo.title}</h2>
        <p className="text-foreground-600 mb-6 leading-relaxed text-sm md:text-base">{contactInfo.desc}</p>

        <div className="flex flex-wrap gap-4 justify-center mb-6">
          {contactInfo.tips.map((tip) => (
            <span key={tip} className="inline-flex items-center gap-1.5 px-3 py-2 bg-accent-50 border border-accent-200/60 rounded-lg text-xs text-accent-700 font-medium">
              <i className="ri-checkbox-circle-line text-accent-500"></i>
              {tip}
            </span>
          ))}
        </div>

        <div className="inline-flex items-center gap-3 px-6 py-3 bg-background-50 border border-background-200 rounded-lg">
          <i className="ri-mail-line text-primary-500 text-lg"></i>
          <span className="text-sm text-foreground-700 font-medium">{contactInfo.email}</span>
        </div>
      </div>
    </section>
  );
}